'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jQuery = require('jQuery');

var _jQuery2 = _interopRequireDefault(_jQuery);

var _Cookies = require('Cookies');

var _Cookies2 = _interopRequireDefault(_Cookies);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _Url = require('urlinator/Url');

var _Url2 = _interopRequireDefault(_Url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REMEMBER_DEFAULT = _Cookies2.default.get('prefs') === '1';

exports.default = {
  login: function login(credentials, lb) {
    credentials.rememberLogin = credentials.rememberLogin !== undefined ? credentials.rememberLogin : REMEMBER_DEFAULT;
    return _q2.default.Promise.resolve(_jQuery2.default.ajax({
      method: 'POST',
      url: new _Url2.default('/login-api/v1/login', { lb: lb }).href,
      contentType: 'application/json',
      xhrFields: { withCredentials: true },
      data: JSON.stringify(credentials)
    }));
  },
  prep: function prep(lb) {
    return _q2.default.Promise.resolve(_jQuery2.default.ajax({
      method: 'POST',
      url: new _Url2.default('/login-api/v1/login/prep', { lb: lb }).href,
      contentType: 'application/json',
      xhrFields: { withCredentials: true }
    }));
  },
  verify: function verify(_ref) {
    var firstAttempt = _ref.firstAttempt,
        email = _ref.email;

    var params = { fallback: !firstAttempt };
    if (email) {
      params.email = email;
    } else {
      params.hubspotutk = _Cookies2.default.get('hubspotutk');
    }
    return _q2.default.Promise.resolve(_jQuery2.default.ajax({
      method: 'POST',
      url: new _Url2.default('/login-api/v1/cookie-verify', { lb: 'api', params: params }).href,
      xhrFields: { withCredentials: true }
    }));
  }
};
module.exports = exports['default'];